import { render, staticRenderFns } from "./the-side-menu.vue?vue&type=template&id=29f17b98&scoped=true&"
import script from "./the-side-menu.vue?vue&type=script&lang=ts&"
export * from "./the-side-menu.vue?vue&type=script&lang=ts&"
import style0 from "./the-side-menu.vue?vue&type=style&index=0&id=29f17b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f17b98",
  null
  
)

export default component.exports